import _ from 'lodash';
import i18n from 'utils/i18n';
import { FormFieldsConstants } from 'utils/constants/form-constants';

const translationKeyStart = '[translation|';

export const createTranslationField = ( field, language ) => {
	const name = `${translationKeyStart}${ language.code?.toLowerCase() }]${field}`;

	return {
		name: name,
		formField: {
			name: name,
			label: i18n.t( `management:form.${field}.title`) +' ('+ i18n.t(`management:languages.${language.code?.toLowerCase()}`) +')',
			type: FormFieldsConstants.TEXT
		}
	};
}

export const retrieveTranslationFields = ( values ) => {
	let translations = [];

	_.forEach( values, ( value, key ) => {
		if( key.includes( '[translation' ) && !_.isEmpty( value )){
			const [ identifier, field ] = key.split( ']' );
			const language_code = identifier.split( '|' )[ 1 ];

			const translationField = field === 'description' ? 'description' : 'title';

			translations.push({
				field: field,
				language: { code: language_code },
				[ translationField ]: value
			});
		}
	});

	return translations;
}

export const createTranslationMutationParameters = ( values ) => {
	const parameters = [];

	_.forEach( values, ( value, key ) => {
		if( _.startsWith( key, translationKeyStart ) ) {
			// table, table_key, field, content, language_code
			const languageCode = key.substring(
				key.lastIndexOf( "|" ) + 1,
				key.lastIndexOf( "]" )
			);

			const fieldKey = key.substring( key.indexOf( ']' ) + 1 );
			let field = null;
			switch( true ) {
				case [ 'name', 'title' ].includes( fieldKey ):
					field = 'title';
					break;

				case [ 'count' ].includes( fieldKey ):
					field = 'count';
					break;

				case [ 'subject' ].includes( fieldKey ):
					field = 'subject';
					break;

				case [ 'content' ].includes( fieldKey ):
					field = 'content';
					break;

				default:
					field = 'description';
			}

			parameters.push({
				language_code: languageCode,
				field: field,
				content: value
			});
		}
	});

	return parameters;
}

